export default () => ({
  imageUpload: {
    maxWidth: '100%',
    maxHeight: '80vh',
  },
  chip: { cursor: 'pointer' },
});
